/**
 * Simple Client-Side Logger
 *
 * Respects the "verbose-logger" feature flag.
 */

import neff from 'neff';

// default log function is a noop
export let log = () => {};

// if you have "verbose-logger" feature enabled
// you get logging in your console instead.
if (neff.isEnabled('verbose-logging') && window.console) {
    log = (...args) => console.log(...args); // eslint-disable-line no-console
}


/** WEBPACK FOOTER **
 ** ./vendor/verbose-logger/index.js
 **/